import React, { useEffect } from 'react';

import { BsArrowUp, BsArrowDown } from 'react-icons/bs';
import { HiArrowsUpDown } from 'react-icons/hi2';

import { Input, Text, Button, Select } from 'v3/components';
import Modal from './Modal';
import theme from 'v3/theme';

import { useRoute } from '../context';
import { GROUP } from '../utils';

function Filter({ modal }) {
  const route = useRoute();

  useEffect(() => {
    route.setFilter((old) => ({ ...old, group: GROUP[0], order: false }));
  }, []);

  useEffect(() => {
    function onPressedKey(e) {
      if (e.key === 'Enter') {
        route.fetchData();
      }
    }

    window.addEventListener('keyup', onPressedKey);

    return () => {
      window.removeEventListener('keyup', onPressedKey);
    };
  });

  return (
    <>
      <Modal isOpen={modal.isOpen} onClose={modal.close} />
      <div className="mt-5">
        <div className="row align-items-center">
          <div className="col-12 d-flex" style={{ gap: 12 }}>
            <Input
              className="flex-grow-1"
              placeholder="Digite cliente/CNPJ ou cidade"
              IconSpaceColor="#fff"
              value={route.filter.main}
              onChange={(e) => route.setFilter((old) => ({ ...old, main: e.target.value }))}
            />
            <Button className="px-5" variant="success" onClick={() => route.fetchData()}>
              <Text type="regular" color="white" weight="500">
                Filtrar
              </Text>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

function OrderBy() {
  const route = useRoute();

  return (
    <div className="row align-items-center mt-3 mb-4">
      <div className="col-12 d-flex align-items-center justify-content-end" style={{ gap: 12 }}>
        <HiArrowsUpDown color={theme.colors.dark} size={28} />

        <Text type="regular" color="dark" weight="semiBold">
          ordenar por:
        </Text>

        <div style={{ width: 220 }}>
          <Select
            options={GROUP}
            value={route.filter.group}
            onChange={(value) => {
              route.setFilter((old) => ({ ...old, group: value }));
              route.fetchData();
            }}
            getOptionLabel={(option) => option?.label}
            getOptionValue={(option) => option?.value}
          />
        </div>

        <Button
          style={{ height: 44, width: 60 }}
          className="p-0"
          variant="secondary"
          onClick={() => {
            route.setFilter((old) => ({
              ...old,
              order: !route.filter.order,
            }));
            route.fetchData();
          }}
        >
          {route.filter.order ? <BsArrowUp size={20} /> : <BsArrowDown size={20} />}
        </Button>
      </div>
    </div>
  );
}

export { OrderBy };
export default Filter;
